import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { Observable } from "rxjs";
import { filter, switchMap, take, withLatestFrom } from "rxjs/operators";

import { CORE_ROUTE } from "../../route";
import { CoreState } from "../../state";
import { AuthenticationStatus } from "../auth.model";
import { AuthSelector } from "../auth.selector";

/**
 * Similar to `AuthSecureGuard` defined in `@obg/ngx.core` but instead
 * of redirecting to login page to authenticate the user, it shows the login dialog on top of the page.
 */
@Injectable({
	providedIn: "root",
})
export class ActionParamAuthSecureGuard implements CanActivate {
	constructor(private store: Store<CoreState>) {}

	canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.store.select(AuthSelector.getAuthenticationStatus).pipe(
			filter((status) => status !== AuthenticationStatus.Pending),
			take(1),
			withLatestFrom(this.store.select(RouteSelector.getCurrent)),
			switchMap(([status, currentRoute]) => {
				if (status === AuthenticationStatus.Authenticated) {
					// todo: investigate why this fixes the page doesn't load on refresh issue
					return Promise.resolve(true);
				}

				this.store.dispatch(
					RouteAction.navigate(
						currentRoute ? currentRoute.name : CORE_ROUTE.home,
						currentRoute ? currentRoute.params : undefined,
						{
							queryParams: {
								returnUrl: state.url,
								action: CORE_ROUTE.auth.login,
							},
							queryParamsHandling: "merge",
						}
					)
				);

				return Promise.resolve(false);
			})
		);
	}
}
